<template>
  <div>
    <ModalComponent
      name="manage-assets"
      class="ml-96 2xl:ml-[36rem]"
      height="auto"
      :adaptive="true"
      :scrollable="true"
      :click-to-close="false"
    >
      <form
        class="p-6"
        @submit.prevent="saveAsset"
      >
        <div
          class="flex items-center justify-between border-b border-[#EDEDED] pb-4"
        >
          <div class="gap-1.5">
            <h3 class="text-lg font-semibold text-primary lg:text-xl">
              Edit Entry
            </h3>
            <p class="text-sm text-primary/50">
              Edit your entry data
            </p>
          </div>
          <button
            class="flex h-12 w-12 items-center justify-center rounded-md bg-[#EEEFF0D4] text-[#808080] outline-none"
            @click="cancelAssetManager"
          >
            <TimesSmall />
          </button>
        </div>

        <div class="mb-16 mt-8 flex flex-col gap-y-3">
          <div class="flex flex-col gap-1">
            <label
              class="text-sm font-medium"
              for="asset-ownership-date"
            >Item Description</label>
            <label
              class="text-sm font-normal"
              for="asset-ownership-date"
            >Electricity Sold</label>
          </div>

          <div class="flex flex-col gap-1">
            <label
              class="text-sm font-medium"
              for="asset-ownership-date"
            >Activity Date</label>
            <TextInput
              id="asset-ownership-date"
              type="date"
              :val="orgAsset"
              @input="orgAsset = $event"
            />
          </div>

          <div class="flex flex-col gap-y-1">
            <label class="text-sm font-medium">Input Data - Scope 1 Emission</label>
            <TextInput
              id="asset-gap"
              type="text"
              :val="orgAsset"
              @input="orgAsset = $event"
            />
          </div>

          <div class="flex flex-col gap-y-1">
            <label class="text-sm font-medium">Input Data - Scope 2 Emission</label>
            <TextInput
              id="asset-name"
              type="text"
              :val="orgAsset"
              @input="orgAsset = $event"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium">Input Unit</label>
            <DropDownInput
              display-key="region_name"
              value-key="region_code"
              :options="regions"
              :first-value="orgAsset.geolocation"
              max-width-class="max-w-full"
              @value-updated="orgAsset.geolocation = $event"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium">Emission Factor</label>
            <DropDownInput
              display-key="region_name"
              value-key="region_code"
              :options="regions"
              :first-value="orgAsset.geolocation"
              max-width-class="max-w-full"
              @value-updated="orgAsset.geolocation = $event"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium">Asset</label>
            <DropDownInput
              display-key="region_name"
              value-key="region_code"
              :options="regions"
              :first-value="orgAsset.geolocation"
              max-width-class="max-w-full"
              @value-updated="orgAsset.geolocation = $event"
            />
          </div>
          <div class="flex flex-col gap-1">
            <label
              class="text-sm font-medium"
              for="asset-emission-categories"
            >Emission Categories</label>
            <MultiSelector
              ref="emissionCategoriesCombobox"
              :options="emissionCategories"
              :options-to-edit="selectedCatgories"
              display-prop="name"
              value-prop="id"
              @values-updated="updateCatgories"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium">Data Collection Frequency</label>
            <DropDownInput
              display-key="name"
              value-key="id"
              :options="frequencies"
              :first-value="orgAsset.data_collection_frequency"
              max-width-class="max-w-full"
              @value-updated="orgAsset.data_collection_frequency = $event"
            />
          </div>
        </div>

        <div
          class="flex items-center justify-end gap-5 border-t border-[#EDEDED] pt-16"
        >
          <GhostButton @click="cancelAssetManager">
            Cancel
          </GhostButton>
          <PrimaryButton
            type="submit"
            aria-label="Save"
            :disabled="cantSaveAsset"
          >
            Save changes
          </PrimaryButton>
        </div>
      </form>
    </ModalComponent>
  </div>
</template>

<script>
export default {
  name: 'EditEmissionAuditLogModal',

  props: {
    asset: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    setting: {
      type: String,
      required: true,
    },
    emissionCategories: {
      type: Array,
      required: true,
    },
  },

  emits: ['savingAsset', 'refresh', 'close'],

  data() {
    return {
      selectedCatgories: [],
      updatedCategories: [],
      regions: [],
      orgAsset: null,
      errorMessage: null,
      timesCategoriesChanged: 0,
    }
  },

  mounted() {
    this.$apis.efdb.listRegions().then(({ data: regionsData }) => {
      this.regions = regionsData
      this.$modal.show('manage-assets')
    })
  },

  methods: {
    saveAsset() {
      this.$emit('savingAsset', { status: true })

      const data = { ...this.orgAsset, emission_categories: this.categories };
      ['description', 'ownership', 'ownership_date'].forEach((key) => {
        if (!data[key]) {
          data[key] = null
        }
      })

      // Todo
      if (!this.editing) {
        this.$apis.assets
          .create(data)
          .then(() => {
            this.$modal.hide('manage-assets')
            this.$toast.success(
              `Your asset ${data.asset_name} has been created successfully!`,
              {
                timeout: 3000,
                position: 'top-right',
              },
            )
            this.$emit('refresh')
          })
          .finally(() => this.$emit('savingAsset', { status: false }))
      }
      else {
        this.$apis.assets
          .update(this.asset.id, data)
          .then(() => {
            this.$modal.hide('manage-assets')
            this.$toast(
              `Your asset ${data.asset_name} has been updated successfully!`,
              {
                timeout: 3000,
                position: 'top-right',
              },
            )
            this.$emit('refresh')
          })
          .finally(() => this.$emit('savingAsset', { status: false }))
      }
    },
    cancelAssetManager() {
      this.$modal.hide('manage-assets')
      this.$emit('close')
    },
    updateCatgories(categories) {
      this.timesCategoriesChanged++
      this.updatedCategories = categories
    },
  },
}
</script>
